import React , { useState ,useEffect } from 'react';
import './styles.scss';
import { Link } from 'react-router-dom';
import { landingPageApi } from '../../api/landing-page-api';

import img from '../../assets/images/logo/log-footer.png'
import img1 from '../../assets/images/logo/logo-footer-dark.png'

const DEFAULT_SOCIAL_MEDIA = [
    { icon: 'icon-instagram', path: 'https://instagram.com/tradiora' },
    { icon: 'icon-twitter', path: 'https://twitter.com/tradiora' },
    { icon: 'icon-youtube', path: 'https://youtube.com/@tradiora' },
    { icon: 'icon-facebook-f', path: 'https://facebook.com/tradiora' },
];

const DEFAULT_CONTACT = {
    emails: ['support@tradiora.id'],
    phones: ['+62 896-2048-5769'],
    address: 'Jl. Jend. Gatot Subroto No.67, Purwokerto, Banyumas, Jawa Tengah 53116',
};

function Footer(props) {

    const [productLink] = useState([
        { title: 'AI Analysis', path: '#features' },
        { title: 'Paper Trading', path: '#features' },
        { title: 'Akademi Trading', path: '#features' },
        { title: 'Komunitas', path: '#features' },
        { title: 'Mentoring', path: '/mentor' },
        { title: 'Download App', path: '#download' },
        { title: 'Event & Webinar', path: '/event' },
    ]);
    const [servicesLink] = useState([
        { title: 'FAQ', path: '/faq' },
        { title: 'Kontak', path: '/contact' },
        { title: 'Blog', path: '/blog-default' },
        { title: 'Kebijakan Privasi', path: '/kebijakan-privasi' },
        { title: 'Syarat & Ketentuan', path: '#' },
        { title: 'Syarat Ketentuan Mentor', path: '/syarat-ketentuan-mentor' },
    ]);

    const [listSocial, setListSocial] = useState(DEFAULT_SOCIAL_MEDIA);
    const [contactInfo, setContactInfo] = useState(DEFAULT_CONTACT);

    useEffect(() => {
        landingPageApi.getSocialMedia().then(data => {
            if (data && data.items && data.items.length > 0) {
                setListSocial(data.items.map(item => ({
                    icon: item.icon,
                    path: item.url,
                })));
            }
        });
        landingPageApi.getContactInfo().then(data => {
            if (data) {
                setContactInfo({
                    emails: data.emails || DEFAULT_CONTACT.emails,
                    phones: data.phones || DEFAULT_CONTACT.phones,
                    address: data.address || DEFAULT_CONTACT.address,
                });
            }
        });
    }, []);
    const [isVisible, setIsVisible] = useState(false);

    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    };
  
    useEffect(() => {
      const toggleVisibility = () => {
        if (window.pageYOffset > 500) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      };
  
      window.addEventListener("scroll", toggleVisibility);
  
      return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    return (

        <footer className="footer style-2">
            <div className="container">
                <div className="footer__main">
                <div className="row">
                    <div className="col-xl-4 col-md-6">
                    <div className="info">
                        <Link to="/" className="logo light">
                        <img src={img} alt="Tradiora" />
                        </Link>
                        <Link to="/" className="logo dark">
                        <img src={img1} alt="Tradiora" />
                        </Link>
                        <p style={{ marginTop: 16, lineHeight: 1.8 }}>
                        Tradiora adalah platform mentoring premium yang menghubungkan 
                        investor dengan mentor profesional. Belajar, diskusi, dan 
                        kembangkan potensi investasi Anda.
                        </p>
                        <ul className="list" style={{ marginTop: 20 }}>
                        {contactInfo.emails.map((email, i) => (
                            <li key={`email-${i}`}><p>{email}</p></li>
                        ))}
                        {contactInfo.phones.map((phone, i) => (
                            <li key={`phone-${i}`}><p>{phone}</p></li>
                        ))}
                        <li>
                            <p>{contactInfo.address}</p>
                        </li>
                        </ul>
                    </div>
                    </div>
                    <div className="col-xl-4 col-md-6">
                    <div className="widget">
                        <div className="widget-link">
                        <h6 className="title">PRODUK</h6>
                        <ul>
                            {
                                productLink.map((data,idx) => (
                                    <li key={idx}><Link to={data.path}>{data.title}</Link></li>
                                ))
                            }
                        </ul>
                        </div>
                        <div className="widget-link s2">
                        <h6 className="title">DUKUNGAN</h6>
                        <ul>
                            {
                                servicesLink.map((data,idx) => (
                                    <li key={idx}><Link to={data.path}>{data.title}</Link></li>
                                ))
                            }
                        </ul>
                        </div>
                    </div>
                    </div>
                    <div className="col-xl-4 col-md-12">
                    <div className="footer-contact">
                        <h5>Ikuti Kami</h5>
                        <p>
                        Dapatkan update terbaru dan tips trading setiap minggu.
                        </p>
                        <form action="#">
                        <input
                            type="email"
                            placeholder="Email Anda"
                            required=""
                        />
                        <button type="submit" className="btn-action">Langganan</button>
                        </form>
                        <ul className="list-social">
                            {
                                listSocial.map((data,idx) => (
                                    <li key={idx}>
                                        <a href={data.path} target="_blank" rel="noopener noreferrer"><span className={data.icon}></span></a>
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div className="container-fluid">
                <div className="footer__bottom">
                <p>
                    &copy;2026 Tradiora. All rights reserved. 
                </p>
                </div>
            </div>

            {
                isVisible && 
                <Link onClick={scrollToTop}  to='#' id="scroll-top"></Link>
            }
        </footer>
    );
}

export default Footer;
